import React, { Fragment, useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Delete from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import CloseIcon from '@material-ui/icons/Close';
import MonetizationOn from '@material-ui/icons/MonetizationOn';
import Modal from '../../../shared/components/Modal';
import ModalMat from '@material-ui/core/Modal';
import RepeatIcon from '@material-ui/icons/Repeat';
import { useEffect } from 'react';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import ImageIcon from '@material-ui/icons/Image';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStream } from "@fortawesome/free-solid-svg-icons";
import ZoomInIcon from '@material-ui/icons/ZoomIn';

const ReactTableActionsPayments = ({ refresh, data, getPaymentById, invoiceToEdit }) => {

    const [isDelete, setIsdeleted] = useState(false);
    const [modalAlert, setModalAlert] = useState({ title: '', color: '', message: '' });

    useEffect(() => {
        console.log("COMINTOACTIOS", data)
    }, [])

    const onDelet = () => {
        setIsdeleted(false);
        //setIsLoading(true);
        let dataSend = { id_pago: data.data.original.id_pago };
        console.log(dataSend);
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'pagos/delete', {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then(response => {
                    console.log(response);
                    refresh();
                    getPaymentById(data.data.original.id_factura_t);
                    setModalAlert({ title: 'Acción completada', color: 'success', message: 'El pago fue eliminado' });
                    return response.json();
                })
                .then(data => {
                    resolve(true);
                })
                .catch((error) => {
                    resolve(error);
                });
        })
    }

    const onOkModal = () => {
        switch (modalAlert.color) {
            case "success":
                setIsdeleted(!isDelete);
                break;
            case "warning":
                onDelet();
                break;
        }
    }

    const onToggleShowPayment = (id_invoice) => {
        getPaymentById(id_invoice);
    }

    const onToggleToEdit = (payment) => {
        invoiceToEdit(payment, true);
    }

    return (
        <Fragment>
            <td role="cell">

                <Tooltip title="Ver Pago">
                    <IconButton aria-label="edit" onClick={() => {
                        onToggleShowPayment(data.data.original.id_factura_t);
                    }}>
                        <ZoomInIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Editar pago">
                    <IconButton
                        aria-label="edit"
                        // disabled={imageShow == undefined && imageShow == null ? true : false}
                        onClick={() => {
                            onToggleToEdit(data.data.original);
                        }}>
                        <EditOutlinedIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title="">
                    <IconButton aria-label="delete" onClick={() => {
                        setIsdeleted(true);
                        setModalAlert({ title: 'Advertencia', color: 'warning', message: '¿Deseas eliminar este pago?' });
                    }}>
                        <DeleteForeverIcon />
                    </IconButton>
                </Tooltip>
                {isDelete ?
                    <Modal
                        color={modalAlert.color}
                        title={modalAlert.title}
                        message={modalAlert.message}
                        modal={isDelete}
                        onOk={() => onOkModal()}
                        toggle={() => { setIsdeleted(!isDelete) }}
                    />
                    : null}
            </td>
        </Fragment>
    )
}

export default ReactTableActionsPayments;